import React from "react";
import { Box, Typography, IconButton, Button, Avatar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ServerBusyImage from "../../assets/server busy.png";

const ServerBusyModal = ({ setServerBusy, onTryAgain }) => {
  const handleClose = () => {
    setServerBusy && setServerBusy(false);
  };

  const handleTryAgain = () => {
    onTryAgain ? onTryAgain() : handleClose();
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        px: 2,
      }}
    >
      <Box
        sx={{
          position: "relative",
          bgcolor: "#fff",
          borderRadius: "16px",
          width: "100%",
          maxWidth: 340,
          p: 3,
          pt: 5,
          textAlign: "center",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#333",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Illustration */}
        <Box
          sx={{
            position: "relative",
            width: 150,
            height: 110,
            mx: "auto",
            mb: 3,
          }}
        >
          <Box
            component="img"
            src={ServerBusyImage}
            alt="Server is busy"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />


        </Box>

        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 19,
            color: "#22314F",
            mb: 1.5,
          }}
        >
          Server Is Busy Right Now
        </Typography>

        <Typography
          sx={{
            fontSize: 13.5,
            color: "#8A94A6",
            lineHeight: 1.6,
            mb: 3,
          }}
        >
          We're Receiving A High Volume Of Requests. Please Try Again In A
          Few Moments.
        </Typography>

        <Button
          fullWidth
          variant="contained"
          onClick={handleTryAgain}
          sx={{
            bgcolor: "#0AA36D",
            color: "#fff",
            fontWeight: 700,
            textTransform: "none",
            borderRadius: "10px",
            py: 1.3,
            boxShadow: "none",
            "&:hover": { bgcolor: "#0AA36D" },
          }}
        >
          Try Again
        </Button>
      </Box>
    </Box>
  );
};

export default ServerBusyModal;
